export default "__VITE_ASSET__CTPbejgI__"